<mat-dialog-actions>
    <button mat-icon-button type="button" aria-label="close dialog" mat-dialog-close tabindex="-1"
            style="position:absolute; top:0; right:0;">
        <mat-icon>close</mat-icon>
    </button>
</mat-dialog-actions>
<form [formGroup]="statusTypeForm" (ngSubmit)="onSubmit()" class="p-2 m-1 px-5">
    <div>
        <h5>STATUS</h5>
        
    </div>
    <mat-dialog-content *ngIf="isLoading">
        <mat-spinner ></mat-spinner>
    </mat-dialog-content>
    
    <mat-dialog-content *ngIf="!isLoading && !errorMessage" class="d-flex flex-column">
        <mat-form-field>
            <mat-label>Wiadomość</mat-label>
            <input matInput type="text" required formControlName="id">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Nazwa</mat-label>
            <input matInput type="text" required formControlName="name">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Opis</mat-label>
            <textarea matInput formControlName="description"></textarea>
        </mat-form-field>
        <mat-button-toggle-group formControlName="type">
            <mat-button-toggle [value]="0">Info</mat-button-toggle>
            <mat-button-toggle [value]="1">Awaria</mat-button-toggle>
        </mat-button-toggle-group>

        <button mat-button type="submit">Zapisz!</button>
    </mat-dialog-content>

    <mat-dialog-content *ngIf="errorMessage && !isLoading">
        Coś poszło nie tak :/<br>
        {{errorMessage}}
    </mat-dialog-content>
    
</form>
